<script>
const goBack = () =>  window.history.back();
</script>

<div class="w-5 h-5 fill-current cursor-pointer text-pink-600" on:click={goBack}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M3.828 9l6.071-6.071-1.414-1.414L0 10l.707.707 7.778 7.778 1.414-1.414L3.828 11H20V9H3.828z"/></svg>
</div>